import { render, staticRenderFns } from "./RegisterCreditor.vue?vue&type=template&id=31043412&scoped=true&"
import script from "./RegisterCreditor.vue?vue&type=script&lang=js&"
export * from "./RegisterCreditor.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCreditor.vue?vue&type=style&index=0&id=31043412&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31043412",
  null
  
)

export default component.exports